import Head from 'next/head';
import React from 'react';
import { renderJsonLdScript, getFaqStructuredData } from 'libs/universal/structuredData';

const BASE_URL = 'https://www.zola.com';

const FAQ_LD = [
  {
    question: `Wait, are Zola’s wedding planning tools free?`,
    answer: `Yes! Zola is free to use. How? We make money by selling wedding gifts and stationery from our store. Don't want to register at Zola or use our wedding paper? Our websites, guest list manager, and checklist are still 100% free to use.`,
  },
  {
    question: `How much time do you need to plan a wedding?`,
    answer: `Most couples take about a year to plan their weddings. Whether you just got engaged or you’ve booked your venue, our tools make this time as stress-free as possible no matter where you are on your journey. For more help, visit our <a href="${BASE_URL}/expert-advice">Expert Advice</a> section.`,
  },
  {
    question: `Where should we start when planning a wedding?`,
    answer: `Our wedding <a href="${BASE_URL}/wedding-planning/checklist">checklist</a> is an easy way to figure out what you need to do, which vendors to book, and when. Couples also build their wedding website and send save the dates early on. Check our <a href="${BASE_URL}/expert-advice">Expert Advice</a> section for more guidance.`,
  },
  {
    question: `Can we get started without a confirmed wedding date?`,
    answer: `Absolutely! We suggest building your guest list and collecting addresses. Once you have a venue, date, and time, tell us and we’ll keep you on schedule. Need help setting a date for your special day? Visit <a href="${BASE_URL}/expert-advice/planning-101/getting-started/how-to-set-a-wedding-date">this page</a>.`,
  },
  {
    question: `Do we still need a wedding planner?`,
    answer: `Up to you! We’re here to help throughout your planning. The one thing we can't do? Be there on your wedding day, coordinating like a professional planner with a clipboard and headset. We'll be there in spirit!`,
  },
];

export default function Header(): JSX.Element {
  return (
    <Head>
      <title>Free Online Wedding Planning Tools - Zola</title>
      <meta
        name="description"
        content="Planning your wedding? Make it a breeze with our free tools! From guest lists and paper invitations to a custom website and a master checklist."
      />
      <meta
        name="keywords"
        content="Wedding, Wedding Registry, Honeymoon Fund, Wedding Planning, Guest List, Wedding Checklist, Wedding Website, Free wedding website"
      />
      <meta name="og:title" content="Free Online Wedding Planning Tools - Zola" />
      <meta
        name="og:description"
        content="Zola will do anything for love and is reinventing wedding planning by bringing together your wedding website, registry, checklist and guest list."
      />
      <meta
        name="og:image"
        content="https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/logos/zola-heart-marine.png"
      />
      <link rel="canonical" href="https://www.zola.com/wedding-planning" />
      {renderJsonLdScript(getFaqStructuredData(FAQ_LD))}
    </Head>
  );
}
